// Batch 8.2 — small display helpers for the Founder Portal and the IFRS screens (pure, unit-tested).

// F-39a · elapsed time in minutes AND seconds: "1 min 29 s", "45 s", "12 min 0 s"
export function fmtElapsed(ms) {
  const total = Math.max(0, Math.floor(Number(ms || 0) / 1000));
  const m = Math.floor(total / 60); const s = total % 60;
  return m > 0 ? `${m} min ${s} s` : `${s} s`;
}

// F-39d · Maintenance run progress from the script's PROGRESS lines: percentage by ROWS when the line carries rows
// ("… · rows restored so far X of Y"), by collections otherwise; the text always says "collection i of n · name".
const PROGRESS_RX = /^PROGRESS (\d+)\/(\d+)(?: (\S+))?(?: · rows restored so far ([\d,]+) of ([\d,]+))?/;
export function parseMaintProgress(lines) {
  const prog = [...(lines || [])].reverse().find((l) => PROGRESS_RX.test(l));
  if (!prog) return null;
  const m = prog.match(PROGRESS_RX);
  const i = Number(m[1]); const n = Math.max(1, Number(m[2])); const name = m[3] || "";
  const rowsDone = m[4] ? Number(m[4].replace(/,/g, "")) : null;
  const rowsTotal = m[5] ? Number(m[5].replace(/,/g, "")) : null;
  const pct = rowsDone !== null && rowsTotal ? Math.min(100, Math.round((rowsDone / rowsTotal) * 100)) : Math.round((i / n) * 100);
  const text = `${pct} % · collection ${i} of ${n}${name ? ` · ${name}` : ""}${rowsDone !== null ? ` · rows restored ${fmtCount(rowsDone)} of ${fmtCount(rowsTotal || 0)}` : ""}`;
  return { pct, i, n, name, rowsDone, rowsTotal, text, by: rowsDone !== null ? "rows" : "collections" };
}

// Item 7 · who ran it: "Name · e-mail", "— · e-mail" never a leading " · "; "—" when unknown
export function whoLabel(name, email) {
  const n = (name || "").trim(); const e = (email || "").trim();
  if (n && e) return `${n} · ${e}`;
  if (n) return n;
  if (e) return `— · ${e}`;
  return "—";
}

// F-44 · "Freed 131.6 MB (data 80.9 · indexes 50.7)"; an old run without the split shows the total only
import { gbFromMb } from "./storageFmt";
import { fmtCount } from "@/components/Amount";   // STEP 3 combined · B6b: the one count formatter (Western digits)

// Batch 19 · B1 (F-144): the freed figures in GB (the backend's freed_mb converted); a caller may pass its own formatter that returns the unit
export function freedLabel(run, fmt = gbFromMb) {
  if (!run || run.freed_mb === undefined || run.freed_mb === null) return "";
  const total = fmt(run.freed_mb);
  if (run.freed_data_mb === undefined || run.freed_data_mb === null) return `Freed ${total}`;
  return `Freed ${total} (data ${fmt(run.freed_data_mb)} · indexes ${fmt(run.freed_index_mb || 0)})`;
}

// F-41 · the SOCE footnote names the source actually used for THIS engagement
export function soceFootnoteKeys(sources) {
  const tr = ["ledger", "policy", "none"].includes(sources?.transfer) ? sources.transfer : "none";
  const dv = ["tagged", "payable", "none"].includes(sources?.dividends) ? sources.dividends : "none";
  return [`ifrs.soce.footnoteTransfer.${tr}`, `ifrs.soce.footnoteDividends.${dv}`];
}
